module.exports = __webpack_public_path__ + "media/app/assets/imgs/events/export-cd12f43d2b943365b986001a899c39d1.svg";